import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.005 17A.993.993 0 0 0 23 15.994v-4.988A.998.998 0 0 0 22 10h-1.51c-.68 0-1.353-.464-1.604-1.09l-1.07-3.677C17.555 4.586 16.688 4 15.99 4H7.008c-.557 0-1.006.446-1.01 1v1h1.5c.277 0 .5.232.5.5 0 .276-.23.5-.5.5H.5a.505.505 0 0 1-.5-.5c0-.276.231-.5.5-.5H5V5c.003-1.109.9-2 2.009-2h8.982c1.107 0 2.342.834 2.753 1.862l1.071 3.677c.1.247.404.461.675.461H22c1.112 0 2 .898 2 2.006v4.988A1.993 1.993 0 0 1 22.005 18 3.007 3.007 0 0 1 19 21a3 3 0 0 1-3-3h-6a3 3 0 0 1-3 3c-1.656 0-3-1.343-3.004-3A2.007 2.007 0 0 1 2 15.994V11.5a.5.5 0 0 1 1 0v4.494c0 .553.452 1.006.995 1.006h.176a3.001 3.001 0 0 1 5.658 0h6.34a3.001 3.001 0 0 1 5.66 0h.175zM19 20a2 2 0 1 0 .001-3.999 2 2 0 0 0 0 3.999zM7 20a2 2 0 1 0 .002-3.999A2 2 0 0 0 7 20zM6 8.502c0 .175-.03.342-.083.498h1.58c.279 0 .504.232.504.5 0 .276-.232.5-.503.5H1.505a.507.507 0 0 1-.503-.5c0-.276.232-.5.503-.5h3a.493.493 0 0 0 .496-.498V8.5a.5.5 0 0 1 1 0v.002zM9.5 6h1a.5.5 0 1 1 0 1h-1a.5.5 0 1 1 0-1z"
});

var SvgCar = function SvgCar(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgCar;